{
  "applications": {
    "all_up": "全部在线",
    "applications": "应用数",
    "instances": "实例数",
    "some_down": "离线实例",
    "last_update": "最后更新",
    "loading_applications": "应用加载中...",
    "no_applications_registered": "暂无应用注册。",
    "notifications_suppressed_for": "Notifications on <code>{name}</code> are suppressed for",
    "restricted": "受限的",
    "server_connection_failed": "服务连接失败。",
    "suppress_notifications_on": "Suppress notifications on <code>{name}</code> for",
    "status": "实例状态",
    "label": "应用",
    "up": "在线",
    "shutdown": "Shutdown application <code>{name}</code>?",
    "restart": "Restart application <code>{name}</code>?",
    "restarted": "Successfully restarted application <code>{name}</code>"
  },
  "instances": {
    "shutdown": "Shutdown instance <code>{name}</code>?",
    "open_details": "打开实例详情",
    "restart": "Restart instance <code>{name}</code>?",
    "restarted": "Successfully restarted instance"
  }
}
